import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Gallery } from 'angular-gallery';
import { ProjectFile } from 'projects/app-misc/src/app/modules/project-misc/data/project/project-file';
import { FileOpenerService } from 'projects/app-misc/src/app/modules/project-misc/utils/fileOpener.service';
import {
  ImageGalleryCarouselComponent
} from 'projects/app-misc/src/app/modules/project-misc/view/image-gallery-carousel/image-gallery-carousel.component';
import {
  PdfPreviewDialogComponent
} from 'projects/app-misc/src/app/modules/project-misc/view/pdf-preview-dialog/pdf-preview-dialog.component';
import { TrelloCheckItem } from 'projects/app-misc/src/app/modules/trello-misc/data/trello-check-item';
import { TrelloService } from 'projects/app-misc/src/app/modules/trello-misc/data/trello.service';
import { FileService } from 'projects/core/src/lib/misc/data/file/file.service';
import { trackEntityById, API_URL } from 'projects/core/src/public-api';

@Component({
  selector: 'app-task-checkitem-files',
  templateUrl: './task-checkitem-files.component.html',
  styleUrls: ['./task-checkitem-files.component.scss']
})
export class TaskCheckitemFilesComponent implements OnInit, OnDestroy {

  @Input()
  checkItem: TrelloCheckItem;

  @Input()
  progressBar: number;

  @Input()
  projectId: number;


  trackEntityById = trackEntityById;

  constructor(
    protected fileService: FileService,
    protected fileOpenerService: FileOpenerService,
    @Inject(API_URL) protected apiUrl: string,
    protected trelloService: TrelloService
  ) {
  }

  ngOnInit() {
  }

  deleteFile(file: ProjectFile) {
    if(this.checkItem.id) {
      this.trelloService.deleteFile(file.id, this.checkItem.id).subscribe(deleted => {

        const index = this.checkItem.files.indexOf(file, 0);
        if(index > -1) {
          this.checkItem.files.splice(index, 1);
        }
      })
    } else {
      const index = this.checkItem.files.indexOf(file, 0);
      if(index > -1) {
        this.checkItem.files.splice(index, 1);
      }
    }

  }

  onProgress(event) {
    this.progressBar = event.progress;

    if(this.progressBar === 100) {
    }
  }

  updateProgressBar(percent: number) {
    this.progressBar = percent;
  }

  openFile(projectFile: ProjectFile) {
    this.fileOpenerService.openFile(projectFile, this.checkItem.files, true)
  }

  ngOnDestroy() {

  }

}
